import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LogoutService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
	constructor(private router: Router) { }
	canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const userId = this.getUserId();
		// console.log(userId);
		if(userId) {
			// console.log('userId is here')
			return true;
		}
		this.router.navigate(['/login']);
		return false;
	}

	getUserId() {
		return localStorage.getItem('userId');
	}
}
